import React from "react";

import { Intro } from "components/commons";
import DataTableV2 from "components/commons/data-table/data-table-v2";
import useDataTable from "hooks/useDataTable";
import locale from "localization";

import { mapFilterToRequest, mapDataToList } from "./user-access.mapper";
import { columns } from "./user-access-column";
import { initialFilterState } from "./user-access-filter.state";
import { useApi, useModal } from "hooks";
import UserAccessFilter from "./user-access-filter";
import { getUsers, updateUserStatus } from "apis/profile.api";
import UserAccessForm from "./user-access-form";
import { ProfileType, UserStatus, Portal } from "enums";
import { handleRequest } from "utils";
import { ConfirmModal } from "components/modals";

const UserAccessModule = () => {
  const confirmModal = useModal();
  const { close } = confirmModal;

  const { request: updateStatusRequest } = useApi({
    api: updateUserStatus,
    handleOwnError: {
      badrequest: true,
    },
  });

  const handleUpdateStatus = (params) => {
    const { status, email } = params;
    const activation = status === UserStatus.Active;
    confirmModal.show({
      title: activation ? locale.reactivateUser : locale.deactivateUser,
      content: activation ? (
        <div>
          <locale.Populate text={locale.youAreAboutReactivateUser} items={[<b>{email}</b>]} />
          <br />
          <locale.Populate text={locale.thisWillEnableUser} items={[<b>{email}</b>]} />
        </div>
      ) : (
        <div>
          <locale.Populate text={locale.youAreAboutDeactivateUser} items={[<b>{email}</b>]} />
          <br />
          <locale.Populate text={locale.thisWillTemporaryPreventUser} items={[<b>{email}</b>]} />
        </div>
      ),
      secondary: {
        text: locale.Cancel,
      },
      primary: {
        text: activation ? locale.yesReactivateIt : locale.yesDeactivateIt,
        onClick: async () => {
          submitUpdateStatus(params);
          close();
        },
      },
    });
  };

  const submitUpdateStatus = async (params) => {
    handleRequest(async () => {
      await updateStatusRequest({
        ...params,
        profileType: ProfileType.PT,
      });

      table.fetch({});
    });
  };

  const { filter, search, table } = useDataTable({
    api: {
      api: getUsers,
      params: {
        portal: Portal.PRICETRACQ,
        profileType: ProfileType.PT,
      },
      mapper: (param) => {
        return param;
      },
    },
    filter: { initialState: initialFilterState(), mapper: mapFilterToRequest },
    table: {
      key: "users",
      mapper: (users) =>
        mapDataToList({
          users,
          handleUpdateStatus,
        }),
      columns,
    },
  });

  const userAccessFormModal = useModal();

  return (
    <>
      <ConfirmModal {...confirmModal} />
      <UserAccessForm
        {...userAccessFormModal}
        refreshPage={() => {
          table.refetch();
        }}
      />
      <Intro
        title={locale.userAccess}
        subtitle={locale.monitorUserAccessToPricetracqPortal}
        actionText={locale.addUser}
        actionOnClick={() => {
          userAccessFormModal.show({
            title: locale.addUser,
            initialState: {
              email: {
                value: "",
              },
            },
          });
        }}
      />
      <UserAccessFilter {...filter} {...search} />
      <DataTableV2 {...table} paginationV2 />
    </>
  );
};

export default UserAccessModule;
